import { jsx as _jsx } from "react/jsx-runtime";
import LoadingLogo from '@assets/images/loading.gif';
import { LoaderWrapper } from './LocalLoader.style';
const LocalLoader = () => (_jsx(LoaderWrapper, { children: _jsx("img", { src: LoadingLogo, alt: "Bricks loader" }) }));
export default LocalLoader;
